// Helpers de idioma compartidos entre el calendario y el form de la cita.
// Los consultores que vienen de `available-times` son objetos { name, language }
// con language en { 'english', 'spanish', 'both' }.

// Etiqueta legible para el valor de idioma de un consultor (panel admin / form).
export const LANGUAGE_LABELS = {
  english: 'Inglés',
  spanish: 'Español',
  both: 'Inglés y Español',
};

// Badge corto por idioma para los chips del calendario.
export const LANG_BADGE = {
  english: 'EN',
  spanish: 'ES',
};

// A partir de los consultores de un slot devuelve los códigos de idioma
// disponibles ('english'/'spanish'), en orden fijo (inglés primero).
// Un consultor 'both' aporta ambos idiomas.
export function getSlotLanguageCodes(consultants = []) {
  const codes = new Set();
  consultants.forEach((c) => {
    const lang = typeof c === 'string' ? null : c.language;
    if (lang === 'english' || lang === 'both') codes.add('english');
    if (lang === 'spanish' || lang === 'both') codes.add('spanish');
  });
  return ['english', 'spanish'].filter((l) => codes.has(l));
}
